import React from 'react';

import './icon2__plus.scss';

export default function Icon2Plus() {
    return (
        <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
                clipRule="evenodd"
                d="M8 0.00292969C7.73478 0.00292969 7.48043 0.108287 7.29289 0.295823C7.10536 0.483359 7 0.737713 7 1.00293V7.00293H1C0.734784 7.00293 0.48043 7.10829 0.292893 7.29582C0.105357 7.48336 0 7.73771 0 8.00293C0 8.26815 0.105357 8.5225 0.292893 8.71004C0.48043 8.89757 0.734784 9.00293 1 9.00293H7V15.0029C7 15.2681 7.10536 15.5225 7.29289 15.71C7.48043 15.8976 7.73478 16.0029 8 16.0029C8.26522 16.0029 8.51957 15.8976 8.70711 15.71C8.89464 15.5225 9 15.2681 9 15.0029V9.00293H15C15.2652 9.00293 15.5196 8.89757 15.7071 8.71004C15.8946 8.5225 16 8.26815 16 8.00293C16 7.73771 15.8946 7.48336 15.7071 7.29582C15.5196 7.10829 15.2652 7.00293 15 7.00293H9V1.00293C9 0.737713 8.89464 0.483359 8.70711 0.295823C8.51957 0.108287 8.26522 0.00292969 8 0.00292969Z"
                fill="#020202"
                fillRule="evenodd"
            />
        </svg>
    );
}
/* eslint-enable max-len */
